import {getDevModePathPrefix} from 'uix/deploy'

export const getStoreNames = () => {
  // in npm-dev-mode we use different local-store-keys for different apiurls (path-prefixes of apiurls)
  let prefix = getDevModePathPrefix()

  return {
    dbName: prefix ? `vls/${prefix}` : 'vls',
    storeName: 'uix',
  }
}

// ok we are using a global variable here for tracking creation of persistent structures
// probably ok, since borwser store is also a singleton
export const CREATION_TRACKER = {}
export const reset_tracker = Object.keys(CREATION_TRACKER).forEach(k => delete CREATION_TRACKER[k])
